export class ExpectedError extends Error {
	constructor(message) {
		super(message);
		this.name = 'ExpectedError';
	}
}
